<template>
  <div class="min-h-screen main-admin-container">
    <!-- Top Navigation -->
    <nav 
      ref="navbar"
      class="bg-white shadow-lg border-b border-gray-200 transition-all duration-300 ease-in-out"
      :class="{ 'nav-sticky': isSticky }"
    >
      <div class="w-full mx-auto px-4 sm:px-6 lg:px-8 nav-container">
        <div class="flex justify-between items-center h-16">
          <!-- Logo -->
          <div class="flex items-center flex-shrink-0">
            <router-link
              to="/admin/dashboard"
              class="flex items-center hover:opacity-80 transition-opacity"
            >
              <img
                src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjWba9cb_pkejMGMH7qatIVTvTdJVvF1NZr87pE6PCGXleLLQ1C-68SwWp72ufKhhOXcn0aQthUOqxtQ6Fqn67XnrX2UeWRP85AyKc5nwEKdbAwEQaUTgB4KsXj5iAJqN_LjWNa8G2nFy4tmnz-p2dRlzjbQHqqm_ZL0wEcFSyMYazXkLAF65GcY2wm2VU/s0/_logo-1741262832124.png"
                alt="Selectair Logo"
                class="h-10 w-auto app-logo"
              />
            </router-link>
          </div>

          <!-- Desktop Navigation -->
          <div class="desktop-nav items-center space-x-1 flex-1 justify-end ml-6">
            <!-- Search Bar -->
            <!-- <div class="relative mr-4">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg class="h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </div>
              <input
                v-model="searchQuery"
                @input="handleSearch"
                @focus="showSearchResults = true"
                type="text"
                placeholder="Zoek in navigatie..."
                class="block w-64 pl-14 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-red-500 focus:border-red-500 text-sm"
              >

              <div
                v-if="showSearchResults && filteredNavItems.length > 0"
                class="absolute top-full left-0 mt-1 w-full bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200 max-h-64 overflow-y-auto"
              >
                <router-link
                  v-for="item in filteredNavItems"
                  :key="item.path"
                  :to="item.path"
                  @click="handleNavigation"
                  class="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <span class="font-medium">{{ item.name }}</span>
                  <span v-if="item.parent" class="text-gray-500 text-xs ml-2">in {{ item.parent }}</span>
                </router-link>
              </div>
            </div> -->

            <!-- Navigation Links -->
            <div class="flex items-center space-x-1">
              <!-- Home -->
              <router-link
                to="/admin/home"
                @click="handleNavigation"
                class="nav-link"
                :class="{ 'nav-link-active': $route.path === '/admin/home' }"
              >
                <svg class="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                </svg>
                <span>Home</span>
              </router-link>

              <!-- Informatie Dropdown -->
              <div class="relative">
                <button
                  @click="toggleDropdown('informatie')"
                  class="nav-link"
                  :class="{ 'nav-link-active': isInformatieActive }"
                >
                  <span>Informatie</span>
                  <svg class="h-8 w-8 transition-transform" :class="{ 'rotate-180': dropdowns.informatie }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </button>
                <div v-if="dropdowns.informatie" class="dropdown-menu">
                  <router-link to="/admin/agentmails" @click="handleNavigation" class="dropdown-item">AgentMails</router-link>
                  <router-link to="/admin/agenda" @click="handleNavigation" class="dropdown-item">Agenda</router-link>
                  <router-link to="/admin/tui-statistieken" @click="handleNavigation" class="dropdown-item">TUI Statistieken</router-link>
                  <router-link to="/admin/statuten-en-reglementen" @click="handleNavigation" class="dropdown-item">Statuten en reglementen</router-link>
                  <router-link to="/admin/ledenvoordelen" @click="handleNavigation" class="dropdown-item">Ledenvoordelen</router-link>
                  <router-link to="/admin/wie-is-wie" @click="handleNavigation" class="dropdown-item">Wie is wie</router-link>
                </div>
              </div>

              <!-- Partners -->
              <router-link
                to="/admin/partners"
                @click="handleNavigation"
                class="nav-link"
                :class="{ 'nav-link-active': $route.path === '/admin/partners' }"
              >
                <span>Partners</span>
              </router-link>

              <!-- Marketing Dropdown -->
              <div class="relative">
                <button
                  @click="toggleDropdown('marketing')"
                  class="nav-link"
                  :class="{ 'nav-link-active': isMarketingActive }"
                >
                  <span>Marketing</span>
                  <svg class="h-8 w-8 transition-transform" :class="{ 'rotate-180': dropdowns.marketing }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </button>
                <div v-if="dropdowns.marketing" class="dropdown-menu">
                  <router-link to="/admin/materiaal-bestellen-via-staci" @click="handleNavigation" class="dropdown-item">Materiaal bestellen</router-link>
                  <router-link to="/admin/beeldmateriaal" @click="handleNavigation" class="dropdown-item">Beeldmateriaal</router-link>
                  <router-link to="/admin/cadeaubonnen" @click="handleNavigation" class="dropdown-item">Cadeaubonnen</router-link>
                  <router-link to="/admin/postkaartjes" @click="handleNavigation" class="dropdown-item">Postkaartjes</router-link>
                  <router-link to="/admin/webinars" @click="handleNavigation" class="dropdown-item">Webinars</router-link>
                  <router-link to="/admin/brochures-bestellen" @click="handleNavigation" class="dropdown-item">Brochures bestellen</router-link>
                </div>
              </div>

              <!-- Other Links -->
              <router-link to="/admin/handleidingen" @click="handleNavigation" class="nav-link" :class="{ 'nav-link-active': $route.path === '/admin/handleidingen' }">
                <span>Handleidingen</span>
              </router-link>
              <router-link to="/admin/incentives" @click="handleNavigation" class="nav-link" :class="{ 'nav-link-active': $route.path === '/admin/incentives' }">
                <span>Incentives</span>
              </router-link>
              <router-link to="/admin/wetgeving" @click="handleNavigation" class="nav-link" :class="{ 'nav-link-active': $route.path === '/admin/wetgeving' }">
                <span>Wetgeving</span>
              </router-link>
              <router-link to="/admin/folders" @click="handleNavigation" class="nav-link" :class="{ 'nav-link-active': $route.path === '/admin/folders' }">
                <span>Mappen</span>
              </router-link>
              <router-link to="/admin/tutorials" @click="handleNavigation" class="nav-link" :class="{ 'nav-link-active': $route.path === '/admin/tutorials' }">
                <span>Tutorials</span>
              </router-link>
              
              <router-link to="/admin/users" @click="handleNavigation" class="nav-link" :class="{ 'nav-link-active': $route.path === '/admin/users' }">
                <span>Users</span>
              </router-link>
            </div>
          </div>

          <!-- Tablet/Mobile Search and User Menu -->
          <div class="flex items-center space-x-3 ml-4 flex-shrink-0">
            <!-- Search Icon for Tablet/Mobile -->
            <button
              @click="showMobileSearch = !showMobileSearch"
              class="mobile-only p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
            >
              <svg class="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
            </button>

            <!-- User Menu -->
            <div class="relative flex-shrink-0">
              <button
                @click="showUserMenu = !showUserMenu"
                class="flex items-center space-x-2 p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-100"
              >
                <div class="w-8 h-8 bg-gradient-to-r from-red-500 to-red-600 rounded-full flex items-center justify-center">
                  <span class="text-sm font-semibold text-white">{{ userInitials }}</span>
                </div>
                <svg class="h-8 w-8 hidden sm:block" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
              <div v-if="showUserMenu" class="dropdown-menu right-0" style="z-index: 100; min-width: 200px; max-width: 280px;">
                <div class="px-4 py-2 text-sm text-gray-700 border-b">
                  <div class="font-medium truncate" :title="userEmail">{{ userEmail }}</div>
                </div>
                <router-link to="/admin/dashboard" @click="showUserMenu = false" class="dropdown-item">Dashboard</router-link>
                <button @click="handleLogout" class="dropdown-item w-full text-left">Uitloggen</button>
              </div>
            </div>

            <!-- Mobile Menu Button -->
            <button
              @click="showMobileMenu = !showMobileMenu"
              class="mobile-only p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
            >
              <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path v-if="!showMobileMenu" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
                <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>

        <!-- Mobile Search Bar -->
        <div v-if="showMobileSearch" class="mobile-only py-3 border-t">
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg class="h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
              </svg>
            </div>
            <input
              v-model="searchQuery"
              @input="handleSearch"
              @focus="showSearchResults = true"
              type="text"
              placeholder="Zoek in navigatie..."
              class="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-red-500 focus:border-red-500 text-sm"
            >
            <!-- Mobile Search Results -->
            <div
              v-if="showSearchResults && filteredNavItems.length > 0"
              class="absolute top-full left-0 mt-1 w-full bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200 max-h-64 overflow-y-auto"
            >
                <router-link
                  v-for="item in filteredNavItems"
                  :key="item.path"
                  :to="item.path"
                  @click="handleNavigation"
                  class="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <span class="font-medium">{{ item.name }}</span>
                  <span v-if="item.parent" class="text-gray-500 text-xs ml-2">in {{ item.parent }}</span>
                </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Menu -->
      <div v-if="showMobileMenu" class="mobile-only">
        <div class="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
          <!-- Mobile Navigation Items -->
          <router-link to="/admin/home" @click="handleNavigation" class="mobile-nav-item">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
            </svg>
            Home
          </router-link>

          <!-- Mobile Informatie Section -->
          <div>
            <button @click="toggleMobileDropdown('informatie')" class="mobile-nav-item w-full justify-between">
              <div class="flex items-center space-x-3">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <span>Informatie</span>
              </div>
              <svg class="h-8 w-8 transition-transform" :class="{ 'rotate-180': mobileDropdowns.informatie }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div v-if="mobileDropdowns.informatie" class="ml-8 space-y-1">
              <router-link to="/admin/agentmails" @click="handleNavigation" class="mobile-sub-item">AgentMails</router-link>
              <router-link to="/admin/agenda" @click="handleNavigation" class="mobile-sub-item">Agenda</router-link>
              <router-link to="/admin/tui-statistieken" @click="handleNavigation" class="mobile-sub-item">TUI Statistieken</router-link>
              <router-link to="/admin/statuten-en-reglementen" @click="handleNavigation" class="mobile-sub-item">Statuten en reglementen</router-link>
              <router-link to="/admin/ledenvoordelen" @click="handleNavigation" class="mobile-sub-item">Ledenvoordelen</router-link>
              <router-link to="/admin/wie-is-wie" @click="handleNavigation" class="mobile-sub-item">Wie is wie</router-link>
            </div>
          </div>

          <router-link to="/admin/partners" @click="handleNavigation" class="mobile-nav-item">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
            </svg>
            Partners
          </router-link>

          <!-- Mobile Marketing Section -->
          <div>
            <button @click="toggleMobileDropdown('marketing')" class="mobile-nav-item w-full justify-between">
              <div class="flex items-center space-x-3">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"></path>
                </svg>
                <span>Marketing</span>
              </div>
              <svg class="h-8 w-8 transition-transform" :class="{ 'rotate-180': mobileDropdowns.marketing }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div v-if="mobileDropdowns.marketing" class="ml-8 space-y-1">
              <router-link to="/admin/materiaal-bestellen-via-staci" @click="handleNavigation" class="mobile-sub-item">Materiaal bestellen</router-link>
              <router-link to="/admin/beeldmateriaal" @click="handleNavigation" class="mobile-sub-item">Beeldmateriaal</router-link>
              <router-link to="/admin/cadeaubonnen" @click="handleNavigation" class="mobile-sub-item">Cadeaubonnen</router-link>
              <router-link to="/admin/postkaartjes" @click="handleNavigation" class="mobile-sub-item">Postkaartjes</router-link>
              <router-link to="/admin/webinars" @click="handleNavigation" class="mobile-sub-item">Webinars</router-link>
              <router-link to="/admin/brochures-bestellen" @click="handleNavigation" class="mobile-sub-item">Brochures bestellen</router-link>
            </div>
          </div>

          <router-link to="/admin/handleidingen" @click="handleNavigation" class="mobile-nav-item">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
            </svg>
            Handleidingen
          </router-link>

          <router-link to="/admin/incentives" @click="handleNavigation" class="mobile-nav-item">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            Incentives
          </router-link>

          <router-link to="/admin/wetgeving" @click="handleNavigation" class="mobile-nav-item">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
            Wetgeving
          </router-link>

          <router-link to="/admin/folders" @click="handleNavigation" class="mobile-nav-item">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"></path>
            </svg>
            Folders
          </router-link>

          <router-link to="/admin/users" @click="handleNavigation" class="mobile-nav-item">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
            </svg>
            External Service
          </router-link>

          <router-link to="/admin/tutorials" @click="handleNavigation" class="mobile-nav-item">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h8m-7-9h6a2 2 0 012 2v8a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2z"></path>
            </svg>
            Tutorials
          </router-link>
        </div>
      </div>
    </nav>

    <!-- Click Outside Handler -->
    <div
      v-if="showUserMenu || Object.values(dropdowns).some(d => d) || showSearchResults"
      @click="closeAllMenus"
      class="fixed inset-0 z-40"
    ></div>

    <!-- Content -->
    <main class="pt-10" :class="{ 'content-with-sticky': isSticky }">
      <slot></slot>
    </main>
  </div>
</template>

<script>
export default {
  name: "AdminLayout",
  props: {
    breadcrumb: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      userEmail: "",
      showUserMenu: false,
      showMobileMenu: false,
      showMobileSearch: false,
      showSearchResults: false,
      searchQuery: "",
      dropdowns: {
        informatie: false,
        marketing: false,
      },
      mobileDropdowns: {
        informatie: false,
        marketing: false,
      },
      isSticky: false,
      scrollY: 0,
      navItems: [
        { name: "Home", path: "/admin/home" },
        { name: "AgentMails", path: "/admin/agentmails", parent: "Informatie" },
        { name: "Agenda", path: "/admin/agenda", parent: "Informatie" },
        { name: "TUI Statistieken", path: "/admin/tui-statistieken", parent: "Informatie" },
        { name: "Statuten en reglementen", path: "/admin/statuten-en-reglementen", parent: "Informatie" },
        { name: "Ledenvoordelen", path: "/admin/ledenvoordelen", parent: "Informatie" },
        { name: "Wie is wie", path: "/admin/wie-is-wie", parent: "Informatie" },
        { name: "Partners", path: "/admin/partners" },
        { name: "Materiaal bestellen", path: "/admin/materiaal-bestellen-via-staci", parent: "Marketing" },
        { name: "Beeldmateriaal", path: "/admin/beeldmateriaal", parent: "Marketing" },
        { name: "Cadeaubonnen", path: "/admin/cadeaubonnen", parent: "Marketing" },
        { name: "Postkaartjes", path: "/admin/postkaartjes", parent: "Marketing" },
        { name: "Webinars", path: "/admin/webinars", parent: "Marketing" },
        { name: "Brochures bestellen", path: "/admin/brochures-bestellen", parent: "Marketing" },
        { name: "Handleidingen", path: "/admin/handleidingen" },
        { name: "Incentives", path: "/admin/incentives" },
        { name: "Wetgeving", path: "/admin/wetgeving" },
        { name: "Folders", path: "/admin/folders" },
        { name: "Tutorials", path: "/admin/tutorials" },
        // { name: "External Service", path: "/admin/users" },
        { name: "Users", path: "/admin/users" },
      ],
    };
  },
  computed: {
    userInitials() {
      if (!this.userEmail) return "U";
      const parts = this.userEmail.split("@")[0].split(".");
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return this.userEmail[0].toUpperCase();
    },
    isInformatieActive() {
      return [
        '/admin/agentmails',
        '/admin/agenda',
        '/admin/tui-statistieken',
        '/admin/statuten-en-reglementen',
        '/admin/ledenvoordelen',
        '/admin/wie-is-wie'
      ].some(path => this.$route.path.includes(path));
    },
    isMarketingActive() {
      return [
        '/admin/materiaal-bestellen-via-staci',
        '/admin/beeldmateriaal',
        '/admin/cadeaubonnen',
        '/admin/postkaartjes',
        '/admin/webinars',
        '/admin/brochures-bestellen'
      ].some(path => this.$route.path.includes(path));
    },
    filteredNavItems() {
      if (!this.searchQuery) return [];
      const query = this.searchQuery.toLowerCase();
      return this.navItems.filter(item =>
        item.name.toLowerCase().includes(query) ||
        (item.parent && item.parent.toLowerCase().includes(query))
      );
    },
  },
  mounted() {
    // Get user email from localStorage
    try {
      const user = localStorage.getItem("admin_user");
      if (user) {
        const userData = JSON.parse(user);
        this.userEmail = userData.email || "admin@selectair.com";
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
    }

    // Add scroll listener for sticky nav
    window.addEventListener('scroll', this.handleScroll);
    // Close search when clicking outside
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // Remove listeners
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleDropdown(dropdown) {
      // Close other dropdowns
      Object.keys(this.dropdowns).forEach(key => {
        if (key !== dropdown) {
          this.dropdowns[key] = false;
        }
      });
      this.dropdowns[dropdown] = !this.dropdowns[dropdown];
    },
    toggleMobileDropdown(dropdown) {
      this.mobileDropdowns[dropdown] = !this.mobileDropdowns[dropdown];
    },
    hideAllDropdowns() {
      Object.keys(this.dropdowns).forEach(key => {
        this.dropdowns[key] = false;
      });
    },
    closeAllMenus() {
      this.showUserMenu = false;
      this.hideAllDropdowns();
      this.showSearchResults = false;
    },
    handleLogout() {
      this.$emit("logout");
    },
    handleSearch() {
      this.showSearchResults = this.searchQuery.length > 0;
    },
    clearSearch() {
      this.searchQuery = "";
      this.showSearchResults = false;
      this.showMobileSearch = false;
    },
    handleClickOutside(event) {
      // Close search if clicking outside
      if (!event.target.closest('.relative')) {
        this.showSearchResults = false;
      }
    },
    handleNavigation() {
      // Set flag to indicate this is a navigation (not a page refresh)
      sessionStorage.setItem('isNavigating', 'true');
      this.clearSearch();
      this.hideAllDropdowns();
      this.showMobileMenu = false;
      this.showUserMenu = false;
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      this.isSticky = this.scrollY > 100; // Sticky after scrolling 100px
    },
  },
};
</script>

<style scoped>
.main-admin-container {
  /* background-color: #f8fafc; */
  max-width: 80vw;
  margin: 0 auto;
  padding: 30px;
  padding-top: 20px;
}

/* Navigation Container Styling */
.nav-container {
  padding: 20px 30px;
  transition: all 0.3s ease-in-out;
}

/* Sticky Navigation */
.nav-sticky {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: calc(80vw - 90px);
  margin: 0 auto;
  z-index: 99;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  animation: slideDown 0.3s ease-out;
}

@media screen and (max-width: 768px) {
  .nav-sticky {
    max-width: 95vw;
  }
}

.nav-sticky .nav-container {
  padding: 10px 30px;
}

/* Content adjustment when nav is sticky */
.content-with-sticky {
  margin-top: 80px;
}

/* Slide down animation */
@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Navigation Styles */
.nav-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 1.5rem;
  font-weight: 500;
  color: #374151;
  transition: all 0.2s;
  border-radius: 0.5rem;
  white-space: nowrap;
}

.nav-link:hover {
  color: #dc2626;
  background-color: #f9fafb;
}

.nav-link-active {
  color: #dc2626;
  background-color: #fef2f2;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 0.25rem;
  min-width: 14rem;
  width: max-content;
  display: block;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  z-index: 50;
  border: 1px solid #e5e7eb;
}

/* User dropdown specific styling */
.dropdown-menu.right-0 {
  right: 0;
  left: auto;
  white-space: nowrap;
  overflow: hidden;
}

/* Mobile responsive user dropdown */
@media (max-width: 640px) {
  .dropdown-menu.right-0 {
    min-width: 180px;
    max-width: calc(100vw - 40px);
    right: 10px;
  }
  
  .dropdown-menu.right-0 .truncate {
    max-width: 150px;
  }
}

.dropdown-item {
  display: block;
  padding: 0.5rem 1rem;
  font-size: 1.5rem;
  color: #374151;
  transition: all 0.2s;
}

.dropdown-item:hover {
  background-color: #f3f4f6;
}

/* Mobile Navigation Styles */
.mobile-nav-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  border-radius: 0.5rem;
  transition: all 0.2s;
}

.mobile-nav-item:hover {
  color: #dc2626;
  background-color: #f9fafb;
}

.mobile-sub-item {
  display: block;
  padding: 0.5rem 0.75rem;
  font-size: 1.3rem;
  color: #4b5563;
  border-radius: 0.5rem;
  transition: all 0.2s;
}

.mobile-sub-item:hover {
  color: #dc2626;
  background-color: #f9fafb;
}

/* Responsive adjustments */
/* Custom breakpoint at 1500px for desktop nav */
.desktop-nav {
  display: none;
}

.mobile-only {
  display: block;
}

@media (min-width: 1500px) {
  .desktop-nav {
    display: flex;
  }

  .mobile-only {
    display: none !important;
  }
}

.app-logo {
  height: 35px;
  width: 100%;
}

@media (max-width: 767px) {
  .main-admin-container {
    max-width: 100vw;
    padding: 15px;
    padding-top: 10px;
  }
  .app-logo {
    height: 30px;
  }
}

</style>